import { t } from '@citrite/translate';
import { CtxErrorMapper } from 'CtxErrorMapper/errorConfigMapper';
import { environment } from 'Environment/Environment';
import { getClientVersion } from 'Environment/getClientType';
import { isCitrixChromeApp, isNativeClient } from 'Environment/launchResource/device';
import { LaunchStatus } from 'Environment/launchResource/launchResource';
import {
	LaunchProgressDetails,
	ResourceLaunchProgressMap,
	TroubleshootFixStatus,
} from 'Workspace/ResourceProvider/Context';

export const TROUBLESHOOTING_STATUS = 'troubleshooting';
export type LaunchProgressStatusResult = LaunchStatus | typeof TROUBLESHOOTING_STATUS;

export const RemediationActions: Record<string, string> = {
	RESTART: 'RestartVDA',
	CONTACT_ADMIN: 'ContactAdmin',
	REFRESH_RESOURCE_LIST: 'RefreshResourceList',
};

interface ErrorRemediationDetails {
	recommendationText: string;
	remediationInfo: string;
	remediationActionType: string;
}

export const getLaunchProgressStatus = (
	launchProgressContext: LaunchProgressDetails
): LaunchProgressStatusResult => {
	if (
		launchProgressContext?.troubleshoot &&
		launchProgressContext.status === LaunchStatus.CheckingAvailability
	) {
		return TROUBLESHOOTING_STATUS;
	}
	return launchProgressContext.status;
};

export const shouldDisableBrowserClose = (
	launchProgress: ResourceLaunchProgressMap
): boolean => {
	return Object.keys(launchProgress).some(
		operationId =>
			launchProgress[operationId].status !== LaunchStatus.Cancelling &&
			launchProgress[operationId].status !== LaunchStatus.Failed
	);
};

export const getErrorDetailsFromErrorMapper = (errorType: string) => {
	const erroMapper = CtxErrorMapper.getInstance();
	return {
		description: erroMapper.getLocalizedDescription(errorType),
	};
};

export const getClientVersionInfo = (): string => {
	return isNativeClient()
		? environment.nativeCapabilities?.platform?.appversion
		: getClientVersion() || t('Workspace:desktop_launch_failures.undetected');
};

export const extractErrorRemediationDetails = (
	errorMessage: string
): ErrorRemediationDetails => {
	const errorMapper = CtxErrorMapper.getInstance();
	const recommendationText = errorMapper.getLocalizedRecommendation(errorMessage);
	const remediationInfo = errorMapper
		.getRemediations(errorMessage)[0]
		.getLocalizedDescription();
	const remediationActionType = errorMapper
		.getRemediations(errorMessage)[0]
		.getRemediationAction();
	return {
		recommendationText,
		remediationInfo,
		remediationActionType,
	};
};

export const canShowFixIssueButton = (fixStatus: TroubleshootFixStatus): boolean => {
	return (
		(fixStatus === TroubleshootFixStatus.NOT_STARTED ||
			fixStatus === TroubleshootFixStatus.SUCCEEDED) &&
		!isCitrixChromeApp()
	);
};
